module.exports = __webpack_public_path__ + "static/media/YM80_10.32ee9104.jpg";